var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-tabs grid-x"},_vm._l((_vm.tabs),function(tab){return _c('router-link',{key:("tab-" + (tab.label)),staticClass:"tab cell small-12 medium-3 large-1",attrs:{"to":tab.route}},[_vm._v(" "+_vm._s(tab.label)+" ")])}),1)}
var staticRenderFns = []

export { render, staticRenderFns }